import React, { useState } from 'react';
import { useNavigate, useMatch } from 'react-router-dom';
import { useTheme, Menu, MenuItem, Box } from '@mui/material';
import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import { logout } from './api';
import { useUser } from './context/UserContext';

const HEADER_HEIGHT = 72;

const Layout = ({ children }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user } = useUser();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const hideHeaderOnLogin = useMatch('/login');
  const hideHeaderOnRegister = useMatch('/register');
  const hideHeaderOnInvoicePdf = useMatch('/invoices/:invoiceId/pdf');
  const hideHeaderOnPurchaseOrderPdf = useMatch('/purchase-orders/:poId/pdf');

  const shouldShowHeader = !(
    hideHeaderOnLogin ||
    hideHeaderOnRegister ||
    hideHeaderOnInvoicePdf ||
    hideHeaderOnPurchaseOrderPdf
  );

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    handleClose();
    navigate('/profile');
  };

  const handleLogout = async () => {
    try {
      await logout();
      window.location.href = '/login';
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const layoutStyle = {
    height: shouldShowHeader ? `calc(100vh - ${HEADER_HEIGHT}px)` : '100vh',
    display: 'flex',
    flexDirection: 'column',
  };

  const headerStyle = {
    height: `${HEADER_HEIGHT}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 16px 0 50px',
    backgroundColor: theme.palette.background.default,
  };

  return (
    <div style={{ height: '100vh' }}>
      {shouldShowHeader && (
        <div style={headerStyle}>
          <img src={`${process.env.PUBLIC_URL}/images/Logo.png`} alt="Company Logo" style={{ height: '40px' }} />

          <Box flexGrow={1} />
          <Avatar shape="square" size={40} onClick={handleClick} icon={<UserOutlined />} style={{ backgroundColor: theme.palette.primary.main, cursor: 'pointer' }}>{user ? user.first_name.charAt(0) : ''}</Avatar>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem onClick={handleProfile}>Profile</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </div>
      )}
      <Box style={layoutStyle}>
        {children}
      </Box>
    </div>
  );
};

export default Layout;
